import React, { useMemo, useCallback, useEffect, useState } from 'react';
import MiniModal from './MiniModal';
import ButtonNew from './inputs/ButtonNew';
import Checkbox from './inputs/Checkbox';
import './PublicWarningModal.scss';
import classNames from 'classnames';

const PublicWarningModal = ({
  onExit,
  onContinue,
  duplicateMatrix,
  isAdmin = false,
  isPublic = false,
  isInUse = false,
  isAnonymous = false,
}) => {
  const [dontShowChecked, setDontShowChecked] = useState(false);

  const header = useMemo(() => {
    if (isPublic) {
      return 'You are attempting to edit a Public Matrix';
    }
    if (isInUse) {
      return `You are attempting to edit a Matrix that another user is editing`;
    }
    return `You are attempting to edit a Matrix you don't own`;
  }, [isPublic, isInUse]);

  const mainText = useMemo(() => {
    if (isPublic) {
      if (isAnonymous) {
        return `This Matrix resides in the Public Gallery. If you’d like to explore your own changes, you can create an experiment based on this matrix.`;
      }
      return `This Matrix resides in the Public Gallery. Any changes made to it will
          automatically be pushed to all matrices. Are you sure you want to
          continue? If you’d like, you can instead make a copy of this matrix
          for your private gallery.`;
    }
    if (isInUse) {
      return `This Matrix is currently being edited by another user and cannot be edited here. If you’d like, you can instead make a copy of this matrix
          for your private gallery.`;
    }
    return `This Matrix is not owned by you and cannot be edited. If you’d like, you can instead make a copy of this matrix
          for your private gallery.`;
  }, [isPublic, isInUse, isAnonymous]);

  return (
    <MiniModal onExit={onExit} dark={true}>
      <div className="PublicWarningModal">
        <div className="PublicWarningModal-header-text">
          <div className="PublicWarningModal-header-text red">Warning</div>
          <div className="PublicWarningModal-header-text">{header}</div>
        </div>

        <div className="PublicWarningModal-text">{mainText}</div>
        <div className="PublicWarningModal-text">
          Learn more about how public vs. private galleries work in our{' '}
          <a href="#/faq" target="_blank">
            FAQs
          </a>
        </div>
        {isAdmin && !isInUse ? (
          <div className="PublicWarningModal-checkbox-container">
            <Checkbox
              id="dontShowWarning"
              label={'Don’t show this message again'}
              value={dontShowChecked}
              onChange={() => setDontShowChecked(!dontShowChecked)}
            />
          </div>
        ) : null}
        <div className="PublicWarningModal-buttons-container">
          {isAdmin && !isInUse ? (
            <div className="PublicWarningModal-button-container">
              <ButtonNew
                buttonClasses="secondary-button-dark-small PublicWarningModal-button"
                onClick={() => onContinue(dontShowChecked)}
                label="Continue editing"
              />
            </div>
          ) : null}
          <div
            className={classNames('PublicWarningModal-button-container', {
              full: !isAdmin || isInUse,
            })}
          >
            <ButtonNew
              buttonClasses="primary-button-small PublicWarningModal-button"
              onClick={() => duplicateMatrix(dontShowChecked)}
              label={
                isAnonymous ? 'Create an Experiment' : 'Make a private copy'
              }
            />
          </div>
        </div>
      </div>
    </MiniModal>
  );
};

export default PublicWarningModal;
